<template>
  <div class="w-full">
    <SmartTitle heading="1" weight="medium"> Editar Business Plan </SmartTitle>
    <SmartCard
      class="w-full flex justify-center align-center"
      style="height: 76px"
    >
      <SmartTitle
        heading="2"
        weight="medium"
        style="max-width: 350px"
        class="text-overflow-hidden text-black text-overflow-ellipsis"
      >
        {{ businessPlan.name }}
      </SmartTitle>
    </SmartCard>
    <div class="mt-4">
      <SmartCard class="head align-center">
        <div v-for="column in sharedData.tableHead" :key="column.id">
          <p class="ml-4">{{ column.columnText }}</p>
        </div>
      </SmartCard>
    </div>
    <div>
      <SmartCard
        v-for="(listProduct) in products"
        :key="listProduct.name + '-' + listProduct.segment_id"
        class="card-two flex align-center mt-2 justify-around"
      >
        <div class="w-200">
          <p>
            {{ listProduct.name }}
          </p>
        </div>
        <div>
          <SmartInputMoney
            type="volume"
            v-model="sharedData.tableColumns.volumeBase[listProduct.segment_id]"
          />
        </div>
        <div>
          <SmartInputMoney
            disabled
            type="volume"
            v-model="sharedData.tableColumns.currentVolume[listProduct.segment_id]"
          />
        </div>
        <div>
          <SmartInputMoney
            type="money"
            v-model="sharedData.tableColumns.revenue[listProduct.segment_id]"
          />
        </div>
        <div>
          <SmartInputMoney
            disabled
            v-model="sharedData.tableColumns.currentRevenue[listProduct.segment_id]"
            type="money"
          />
        </div>
      </SmartCard>
      <SmartCard class="w-full flex mt-4" style="height: 75px">
        <div class="flex-3">
          <SmartP> Definir meta por % </SmartP>
          <p class="ml-2">
            Meta do mês atual é baseada numa % definida em cima da meta base
          </p>
        </div>
        <div class="flex flex-1 justify-end align-center mr-2">
          <SmartInput
            type="tel"
            mask="####"
            class="input-weight"
            placeholder="10"
            append="%"
            v-model="weight"
          />
          <SmartButton @click="applyWeight"> Aplicar </SmartButton>
        </div>
      </SmartCard>
      <div class="flex mt-4 justify-end">
        <SmartButton :loading="isLoadingButton" @click="sendInfo">
          Salvar Alterações
        </SmartButton>
      </div>
      <SmartModal v-if="modal" v-bind="modal" @close="modal = null">
        {{ modal.text }}
      </SmartModal>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import createSharedData from "./sharedData";

export default {
  data() {
    return {
      isLoadingButton: false,
      weight: "",
      modal: null,
      sharedData: createSharedData(),
    };
  },
  watch: {
    businessPlan() {
      const businessPlan = this.businessPlan.business_plan;
      this.weight = businessPlan.goal_percentage;
      businessPlan.business_plan_segment.forEach((item) => {
        let diff = 0;

        diff = parseFloat(item.base_volume).toFixed(0).length;
        this.sharedData.tableColumns.volumeBase[item.segment_id] = parseFloat(item.base_volume)
          .toLocaleString('pt-br',{
            minimumSignificantDigits: 10 + diff
          }
        );

        diff = parseFloat(item.base_billing).toFixed(0).length;
        this.sharedData.tableColumns.revenue[item.segment_id] = parseFloat(item.base_billing)
          .toLocaleString('pt-br',{
            minimumSignificantDigits: 10 + diff
          }
        );
      });
    },
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      products: "goalsDistribuition/getProducts",
      businessPlan: "businessPlan/planByPlaceIdGetter",
    }),
  },
  methods: {
    ...mapActions({
      fetchProducts: "goalsDistribuition/fetchProducts",
      updatePlan: "businessPlan/updatePlan",
      getPlanByPlaceId: "businessPlan/getPlanByPlaceId",
    }),
    fillWeightInsidePayload() {
      this.sharedData.payload.goal_percentage = this.weight || 0;
    },
    applyWeight() {
      const mapPercentageResult = (item) => {
        console.log("item", item);
        item = item.toString().replace(/\./g, "").replace(/\,/g, ".");
        const result = this.convertToPercentage(item);
        console.log("result", result);
        return result.toFixed(10);
      };

      this.sharedData.tableColumns.currentVolume =
        this.sharedData.tableColumns.volumeBase.map(mapPercentageResult);
      this.sharedData.tableColumns.currentRevenue =
        this.sharedData.tableColumns.revenue.map(mapPercentageResult);
    },
    convertToPercentage(value) {
      console.log("value", value);
      if (!value) return 0;
      value = value/100;
      return value * parseFloat(this.weight || 0);
    },
    showModal(params) {
      this.modal = {
        type: params.type,
        title: params.title,
        icon: params.icon,
        buttonText: params.buttonText,
        text: params.text,
        routerRedirect: params.routerRedirect,
      };
    },
    englishFormatNumber(number) {
      number = number.toString();

      if (number.indexOf(',')) {
        let formatted = number
          .replace(/\./, '', number)
          .replace(/\,/, '.', number);

        return formatted;
      }

      return number;
    },
    objectSegmentsToPayload() {
      this.products.forEach((item, index) => {
        const segment = {
          base_volume: this.englishFormatNumber(this.sharedData.tableColumns.volumeBase[item.segment_id]),
          base_billing: this.englishFormatNumber(this.sharedData.tableColumns.revenue[item.segment_id]),
          segment_id: item.segment_id,
          business_plan_segment: this.businessPlan.business_plan.business_plan_segment[index].business_plan_segment,
          goals_type_id: this.businessPlan.business_plan.business_plan_segment[index].goals_type_id,
          goal_distribution_enabled: 1,
          id: this.businessPlan.business_plan.business_plan_segment[index].id,
          additional_goals_id: this.businessPlan.business_plan.business_plan_segment[index].additional_goals_id,
        };

        this.sharedData.payload.business_plan_segment.push(segment);
      });
    },
    sendInfo() {
      this.fillWeightInsidePayload();
      this.objectSegmentsToPayload();
      const { id } = this.businessPlan.business_plan;
      const { payload } = this.sharedData;
      this.isLoadingButton = true;
      this.updatePlan({ payload, id })
        .then(() => {
          this.isLoadingButton = false;
          this.showModal({
            type: "success",
            title: "Ok! Tudo certo.",
            icon: "accepted",
            buttonText: "Ok",
            text: "Business Plan atualizados com sucesso!",
            routerRedirect: "BusinessPlan",
          });
        })
        .catch(({ data }) => {
          this.isLoadingButton = false;
          this.showModal({
            type: "warning",
            title: "Ops! Algo deu errado.",
            icon: "alert",
            buttonText: "Ok",
            text: data.message || "Verifique os parametros digitados!",
          });
        });
    },
  },
  mounted() {
    this.fetchProducts();
    const { id } = this.$router.currentRoute.params;
    this.sharedData.payload.place_id = id;
    this.getPlanByPlaceId(id);
  },
};
</script>

<style lang="scss">
.input-weight {
  width: 155px;
}
.card-one {
  height: 76px;
}
.alert {
  border-radius: 4px;
  height: 56px;
}
.div-aux {
  width: 288px;
  margin-right: 23px;
}
.head,
.card-two {
  display: grid;
  height: 50px;
  overflow-y: hidden;
  overflow-x: hidden;
  grid-template-columns: repeat(5, 2fr);
}
.head {
  background: rgba(151, 151, 151, 0.05);
  grid-gap: 3rem;
}
.card-two {
  height: 50px;
  grid-gap: 3rem;
}
.name {
  width: 100px;
}
.w-200 {
  width: 200px;
}
</style>
